import fileExtension from 'file-extension';

const IMAGE_FILE_TYPES = ['jpg', 'jpeg', 'png', 'gif'];
const AUDIO_TYPES = ['mp3', 'wav', 'm4a', 'aac', 'mid', 'midi', 'oga', 'wav', 'weba'];
const MEDIA_FORMATS = {
    mp3: 'audio/mpeg',
    aif: 'audio/x-aiff',
    aac: 'audio/aac',
    mid: 'audio/midi',
    midi: 'audio/x-midi',
    oga: 'audio/ogg',
    wav: 'audio/wav',
    weba: 'audio/webm',

    ogg: 'video/ogg; codecs="theora"',
    h264: 'video/mp4; codecs="avc1.42E01E"',
    webm: 'video/webm; codecs="vp8, vorbis"',
    vp9: 'video/webm; codecs="vp9"',
    hls: 'application/x-mpegURL; codecs="avc1.42E01E"',
    avi : 'video/x-msvideo',
    mpeg: 'video/mpeg',
    ogv: 'video/ogg',
    mp4: 'video/mp4',
    '3gp': 'video/3gpp',
    '3gp2': 'video/3gpp2',
    mov: 'video/mp4'
};

export const convertBytesToHumanReadable = bytes => {
    const i = Math.max(0, Math.floor(Math.log(bytes) / Math.log(1024)));
    return ( bytes / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export const canPlayMedia = mimetype => {
    const container = 'video';
    const elem = document.createElement(container);

    if (typeof elem.canPlayType === 'function') {
        const playable = elem.canPlayType(mimetype).toLowerCase();

        return playable === 'maybe' || playable === 'probably';
    }

    return false;   
}

export const isAudio = type => {
    return AUDIO_TYPES.includes(type);
}

export const canPlayType = type => {
    let mediaType = 'video';

    if (isAudio(type)) {
        mediaType = 'audio';
    }

    const mediaElement = document.createElement(mediaType);

    return ['probably', 'maybe'].includes(mediaElement.canPlayType(MEDIA_FORMATS[type] || type));
}

export const getFileExtension = filename => fileExtension(filename);

export const isFileImage = (filename) => {
    return IMAGE_FILE_TYPES.includes(getFileExtension(filename));
}

export const getFolderPathElements = folderPath => {
    return (folderPath || '').split('.');
}

export const getFolderStack = (folderPath, rootFolderId) => {
    if (!folderPath) {
        return undefined;
    }

    let folders = folderPath;

    if (typeof folderPath === 'string') {
        folders = getFolderPathElements(folderPath);
    }

    return folders.map(folder => folder === 'root' ? rootFolderId : folder).filter(Boolean);
}

export const getCurrentFolder = (folderPath, rootFolderId) => {
    if (!folderPath) {
        return null;
    }

    const folder = (typeof folderPath === 'string' ? getFolderPathElements(folderPath) : [...folderPath]).pop();

    if (rootFolderId && (folder === '' || folder === 'root')) {
        return rootFolderId;
    }

    return folder;
};

export const createFolderPath = folderIds => {
    return folderIds.join('.');
};

export const getUpdatedPath = (folderPathElements, folderId) => {
    if (folderPathElements.includes(folderId)) {
        return folderPathElements.slice(0, folderPathElements.indexOf(folderId) + 1);
    }

    return [...folderPathElements, folderId];
}
